const AuroraNavigation = (function () {
  const settings = {
    name: "aurora-navigation.js",
    debugging: true,
  };

  const elements = {
    button: {
      header: document.querySelectorAll(".js-toggle-navigation") || [],
    },
    wrapper: {
      nav: document.querySelectorAll(".aur-nav-wrapper") || [],
    },
  };

  const toggleMobileHeader = function () {
    elements.button.header.forEach((button) => {
      button.addEventListener("click", (event) => {
        button.classList.toggle("aur-navigation-is-open");
        elements.wrapper.nav.forEach((nav) => nav.classList.toggle("aur-navigation-is-open"));
        document.body.classList.toggle("aur-body-mobile-menu-open");
        AuroraUtils.setCSSVars();
        window.scroll({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      });
    });
  };

  const init = async function () {
    if (settings.debugging) console.log(`${settings.name} :: Start`);
    toggleMobileHeader();
    if (settings.debugging) console.log(`${settings.name} :: Complete`);
  };

  return { init };
})();
